import classnames from 'classnames'
import { FC } from 'react'

import { Button, Placeholder } from '~ui'
import useOpenSeaAsset from './use-opensea-asset'
import { OpenSeaAssetParams } from './types'

import styles from './OpensSeaAsset.module.scss'

const OpenSeaAssetCard: FC<OpenSeaAssetParams> = ({ contactAddress, tokenId }) => {
  const asset = useOpenSeaAsset({
    contactAddress,
    tokenId,
  })

  if (!asset)
    return (
      <div className={classnames(styles['wrapper-loading'])}>
        <Placeholder style={{ width: '100%', height: '100%', borderRadius: '1em' }} />
      </div>
    )

  const { permalink, name, description } = asset

  return (
    <div style={{ perspective: 800, display: 'flex', justifyContent: 'center' }}>
      <div className={styles.wrapper}>
        <video className={styles.video} autoPlay loop muted>
          <source src={asset.animationUrl} type="video/mp4" />
        </video>
        <div className={classnames(styles.info)}>
          <div style={{ marginBottom: 16 }}>
            <a
              style={{ textDecoration: 'none' }}
              rel="noopener noreferrer"
              title="Buy on OpenSea"
              href={permalink}
              target="_blank"
            >
              <div className={styles.title}>{name}</div>
            </a>
            <p className={styles.description}>{description}</p>
          </div>

          <a rel="noopener noreferrer" href={permalink} title="View on OpenSea" target="_blank">
            <Button variant="primary" tabIndex={-1} fluid>
              View on OpenSea
            </Button>
          </a>
        </div>
      </div>
    </div>
  )
}

export default OpenSeaAssetCard
